// Dependencies
// ------------

import castSpells from './form/cast_spells';
import fieldNames from '../constants/field_names';
import getActiveFields from './element/get_active_fields';
import getDefaultValue from '../constants/default_values';
import getFieldValueByName from './form/get_field_value_by_name';
import getFieldValuesByName from './form/get_field_values_by_name';
import getLandingPage from './metadata/get_landing_page';
import getLeadform from './element/get_leadform';
import getPanels from './element/get_panels';
import getSpells from './form/get_spells';
import getVisitorId from './metadata/get_visitor_id';
import getLocale from './metadata/get_locale';
import isIframeForm from './form/is_iframe_form';

// Exports
// -------

export {
  getActiveFields,
  getLandingPage,
  getLeadform,
  getPanels,
  getSpells,
  getVisitorId,
  getLocale
};

/**
 * Returns the country code tied to a specific form
 */
export function getCountryCode(form) {
  return getFieldValueByName(form, fieldNames.countryCode);
}

/**
 * Returns the phone number input into the form
 */
export function getPhoneNumber(form) {
  return getFieldValueByName(form, fieldNames.phoneNumber);
}

/**
 * Returns the full name input into the form
 */
export function getFullName(form) {
  return getFieldValueByName(form, fieldNames.fullName);
}

export function getEmail(form) {
  return getFieldValueByName(form, fieldNames.email);
}

export function getEmailRequired(form) {
  return getFieldValueByName(form, fieldNames.emailRequired);
}

export function getZipCode(form) {
  return getFieldValueByName(form, fieldNames.zipCode);
}

export function getSubjects(form) {
  return getFieldValueByName(form, fieldNames.subjects);
}

export function getReferer(form) {
  return getFieldValueByName(form, fieldNames.referer);
}

export function getReferredByUrl(form) {
  return getFieldValueByName(form, fieldNames.referredByUrl);
}

/**
 * Returns a string containing a list of tutoring-types
 */
export function getTutoringTypes(form) {
  return getFieldValuesByName(form, fieldNames.tutoringType);
}

export function getTimeToCall(form) {
  return getFieldValueByName(form, fieldNames.timeToCall);
}

export function getDialerConsentAccepted(form) {
  return getFieldValueByName(form, fieldNames.dialerConsentAccepted);
}

export function getConversionPage(form) {
  return (isIframeForm(form) ? document.referrer : window.location.href) || (
    getDefaultValue(fieldNames.page)
  );
}

export function getPassword(form) {
  return getFieldValueByName(form, fieldNames.password);
}

export function processSpellsAsHash(form) {
  return castSpells(form)
    .reduce((obj, spell) => {
      obj[`lead_form.${ spell.name.replace('-', '_') }`] = spell.result;
      return obj;
    }, {});
}

export function processSpellsAsString(form) {
  return castSpells(form)
    .map((spell) => `${ spell.name }: ${ spell.result }`)
    .join('|');
}
